import styles from "./styles/ReportsHeader.module.scss";

export default function UploadHeader() {
  return (
    <>
      <span className={styles.header}>بارگذاری تصاویر</span>
    </>
  );
}
